import { render, staticRenderFns } from "./SwitchType.vue?vue&type=template&id=64faa8c3&"
import script from "./SwitchType.vue?vue&type=script&lang=js&"
export * from "./SwitchType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/allianzebpo/public_html/payment/crater/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64faa8c3')) {
      api.createRecord('64faa8c3', component.options)
    } else {
      api.reload('64faa8c3', component.options)
    }
    module.hot.accept("./SwitchType.vue?vue&type=template&id=64faa8c3&", function () {
      api.rerender('64faa8c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/CustomField/types/SwitchType.vue"
export default component.exports